<div class="ct-manager-master-detail-container payments-massive-cntr">
  <h4 style="font-weight: 600;">{{ "MassiveOffer" | translate }}</h4>

  <div class="form-container">
    <ct-form [configuration]="formConfiguration"></ct-form>
    <ct-button [configuration]="searchButton"></ct-button>
  </div>

  <ng-container *ngIf="elements">
    <ng-container *ngIf="elements.length; else noEleTemplate">
      <p-table
        [value]="elements"
        [(selection)]="selectedElements"
        dataKey="Oid"
        [paginator]="true"
        [rows]="10"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
            <th>Stato</th>
            <th>Cliente</th>
            <th>Data inizio fornitura</th>
            <th>Codice offerta</th>
            <th>Data cambio piano</th>
            <th>Consumo Annuo</th>
            <th>POD/PDR</th>
            <th>Energia verde disabilitata</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <p-tableCheckbox [value]="item" />
            </td>
            <td>{{ item.State.Name }}</td>
            <td>{{ item.Company?.DisplayName ?? "" }}</td>
            <td>{{ item.StartAt | date }}</td>
            <td>{{ item.OfferDisplayName }}</td>
            <td>{{ item.PlanChangeDate | date }}</td>
            <td>{{ item.Amount }}</td>
            <td>{{ item.PodPdr ?? "" }}</td>
            <td>{{ item.DisableGreenEnergy ? "Si" : "No" }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Sezione submit separata dalla ricerca: form a larghezza piena + bottone allineato a destra -->
      <div class="submit-form-container">
        <ct-form *ngIf="offerCodeControl" [configuration]="submitFormConfiguration"></ct-form>
        <div class="submit-button-row">
          <ct-button [configuration]="submitButton"></ct-button>
        </div>
      </div>

    </ng-container>

    <ng-template #noEleTemplate>
      <h4>Nessun contratto trovato</h4>
    </ng-template>
  </ng-container>
</div>
